<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="warningRecordTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isHandleOrder" slot-scope="data">
          <span>{{ data.row.isHandleOrder === 1 ? '是' : '否' }}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'DeliveryHomeAppliance',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_HOMEAPPLIANCE',
        formComponent: {
          view: { type: 'component', componentName: 'DeliveryHomeApplianceEdit', noRequest: true },
          edit: { type: 'component', componentName: 'DeliveryHomeApplianceEdit', noRequest: true },
          list: { type: 'default', value: '/modules/userDeliveryOther/userDeliveryOtherList' },
          delete: { type: 'default', value: '/modules/userWechat/userWechatDelete' }
        },
        formInputsData: [{ name: '用户昵称', key: 'nickName', value: '', type: 'text' },
          { name: '手机号', key: 'phone', value: '', type: 'text' },
          { name: '投递时间', key: 'dataTimeRange', value: [], type: 'datetime' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [], filterable: true },
          { name: '站点',
            key: 'siteId',
            value: '',
            type: 'cascader',
            options: [],
            filterable: true,
            props: {
              children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false }},
          { name: '物品名称', key: 'garbageTypeName', value: '', type: 'text' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userDeliveryOther/userDeliveryOtherListImport',
          fileName: '其他类型投递',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '物品名称', key: 'garbageName', type: 'text' },
          { name: '投递总量(个)', key: 'garbageCount', type: 'text' },
          { name: '总积分', key: 'garbageTotalPrice', type: 'text' },
          { name: '社区名称', key: 'communityName', type: 'text' },
          { name: '站点名称', key: 'siteName', type: 'text' },
          { name: '投递时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '操作人员', key: 'employeesUserName', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: { list: [{}] },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      },
      formDialog: {
        visible: true,
        title: ''
      }
    }
  },
  mounted() {
    this.requestcommunityList()
    this.orgTreeList()
  },
  methods: {
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          data.row.garbageTypeId = data.row.garbageTypeId * 1
          this.$store.dispatch('setOtherGarbageDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      this.$api.community.communityNoPageList().then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        this.form.formInputsData[3].data = res.data
      })
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[this.form.formInputsData.length - 2].options = res.data
      })
    }
  }
}
</script>

<style>
</style>
